import { render, staticRenderFns } from "./NotBid.vue?vue&type=template&id=15cee96e&scoped=true"
import script from "./NotBid.vue?vue&type=script&lang=js"
export * from "./NotBid.vue?vue&type=script&lang=js"
import style0 from "./NotBid.vue?vue&type=style&index=0&id=15cee96e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cee96e",
  null
  
)

export default component.exports